"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("@doshexchnage/utils");
function useRenderCellViews() {
    var renderCellViews = (0, react_1.useCallback)(function (record) {
        return [
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-semibold text-default-foreground", children: record.name }) },
            { key: "tier_movement", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: record.tier_movement }) },
            { key: "milestone", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: record.milestone || "—" }) },
            { key: "xp_earned", content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm font-semibold text-primary", children: ["+", record.xp_earned, " XP"] }) },
            { key: "date", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-default-foreground", children: utils_1.Formatting.formatDateTime(new Date(record.date), "yyyy-MM-dd HH:mm") }) },
        ];
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
